var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"vue-phenomenon"},[_c('canvas',{ref:"canvas"}),_vm._t("vertex"),_vm._t("fragment")],2)}
var staticRenderFns = []

export { render, staticRenderFns }